// src/utils/flyToHeader.js
// Анимация «летящих наград» в шапку

/* ───────────── цели в шапке/плашке ───────────── */
const TARGET_SELECTORS = {
  cash   : ['[data-balance-target="cash"]',    '#balance-cash'],
  tickets: ['[data-balance-target="tickets"]', '#balance-tickets'],
  skins  : ['[data-balance-target="skins"]',   '#balance-skins'],
  xp     : ['[data-balance-target="xp"]',      '#balance-xp'],
};

/* ───────────── базовые настройки (можно менять) ───────────── */
export const FLY_CFG = {
  size        : 40,                 // размер частицы
  duration    : 4000,               // ⚠️ 9 сек на сам полёт (медленно)
  delayStep   : 280,                // задержка между частицами (каждая стартует позже)
  arcMin      : 24,                 // дуга ниже…
  arcMax      : 60,                 // …и короче → меньше «выпрыгивает»
  jitterX     : 6,                  // почти нет «болтания» по X
  easing      : 'ease-in-out',      // плавный разгон/торможение
  pulseMs     : 1600,                // подсветка цели
  minParticles: 6,                  // меньше частиц
  maxParticles: 8,
};


/* ───────────── вшитые иконки (всегда видны) ───────────── */
const ICONS_DATA = {
  cash:
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(`
      <svg width="96" height="64" viewBox="0 0 96 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g-cash" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0"   stop-color="#10B981"/>
            <stop offset="1"   stop-color="#059669"/>
          </linearGradient>
        </defs>
        <rect x="4" y="10" rx="8" ry="8" width="88" height="44" fill="url(#g-cash)" stroke="#064E3B" stroke-width="3"/>
        <circle cx="24" cy="32" r="8" fill="#34D399" opacity=".7"/>
        <circle cx="72" cy="32" r="8" fill="#34D399" opacity=".7"/>
        <rect x="40" y="22" width="16" height="20" rx="6" fill="#065F46"/>
        <text x="48" y="36" dominant-baseline="middle" text-anchor="middle" font-size="18" font-family="Inter,system-ui" fill="#FFFFFF">$</text>
      </svg>
    `),

  tickets:
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(`
      <svg width="96" height="64" viewBox="0 0 96 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g-ticket" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#F43F5E"/>
            <stop offset="1" stop-color="#DC2626"/>
          </linearGradient>
        </defs>
        <path d="M8 18h64a6 6 0 0 1 6 6v2a6 6 0 0 0 0 12v2a6 6 0 0 1-6 6H8a4 4 0 0 1-4-4V22a4 4 0 0 1 4-4z" fill="url(#g-ticket)" stroke="#7F1D1D" stroke-width="3" />
        <rect x="22" y="22" width="40" height="20" rx="3" fill="#FEE2E2" opacity=".5"/>
        <text x="42" y="36" dominant-baseline="middle" text-anchor="middle" font-size="16" font-family="Inter,system-ui" fill="#7F1D1D">TICKET</text>
      </svg>
    `),

  xp:
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(`
      <svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g-coin" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stop-color="#F59E0B"/>
            <stop offset="1" stop-color="#FACC15"/>
          </linearGradient>
        </defs>
        <circle cx="32" cy="32" r="26" fill="url(#g-coin)" stroke="#A16207" stroke-width="4"/>
        <text x="32" y="36" dominant-baseline="middle" text-anchor="middle" font-size="18" font-family="Inter,system-ui" fill="#1F2937" font-weight="800">XP</text>
      </svg>
    `),

  skins:
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(`
      <svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="g-skin" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#60A5FA"/>
            <stop offset="1" stop-color="#3B82F6"/>
          </linearGradient>
        </defs>
        <path d="M32 6l16 12-6 20H22l-6-20L32 6z" fill="url(#g-skin)" stroke="#1E40AF" stroke-width="3" />
      </svg>
    `),
};

/* ───────────── утилиты ───────────── */
const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

function pickTarget(type) {
  const sels = TARGET_SELECTORS[type] || [];
  for (const s of sels) {
    const el = document.querySelector(s);
    if (el) return el;
  }
  return null;
}

function ensureLayer() {
  let layer = document.querySelector('.fly-layer');
  if (!layer) {
    layer = document.createElement('div');
    layer.className = 'fly-layer';
    Object.assign(layer.style, {
      position: 'fixed',
      inset: 0,
      pointerEvents: 'none',
      zIndex: 9999,
    });
    document.body.appendChild(layer);
  }
  return layer;
}

function centerOf(rect) {
  return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
}

/** фабрика частицы */
function mkItem({ type, imgSrc, size }) {
  const el = document.createElement('img');
  el.className = `fly-item type-${type}`;
  el.src = imgSrc || ICONS_DATA[type] || ICONS_DATA.cash;
  const px = `${size}px`;
  Object.assign(el.style, {
    position: 'fixed',
    width: px,
    height: px,
    left: '0px',
    top: '0px',
    willChange: 'transform, opacity',
    filter: 'drop-shadow(0 6px 10px rgba(0,0,0,.35))',
    pointerEvents: 'none',
  });
  return el;
}

function pulseTarget(target, ms) {
  target.classList.add('balance-pulse');
  setTimeout(() => target.classList.remove('balance-pulse'), ms);
}

/* ───────────── полёт одной пачки частиц ───────────── */
export function flyToHeader({ type, sourceEl, imgSrc = null, countVisual = 4, cfg = {} }) {
  const target = pickTarget(type);
  if (!target || !sourceEl) return;

  const CFG = { ...FLY_CFG, ...(cfg || {}) };

  const layer = ensureLayer();
  const start = centerOf(sourceEl.getBoundingClientRect());
  const end   = centerOf(target.getBoundingClientRect());

  const vw = window.innerWidth;
  const vh = window.innerHeight;

  const dist = Math.hypot(end.x - start.x, end.y - start.y);
  const arc  = clamp(dist * 0.28, CFG.arcMin, CFG.arcMax);
  const N    = clamp(countVisual, CFG.minParticles, CFG.maxParticles);

  for (let i = 0; i < N; i++) {
    const el = mkItem({ type, imgSrc, size: CFG.size });
    layer.appendChild(el);

    const midXraw =
      start.x +
      (end.x - start.x) * (0.35 + Math.random() * 0.25) +
      (Math.random() * CFG.jitterX * 2 - CFG.jitterX);
    const midX = clamp(midXraw, 20, vw - 20);

    const midYraw = Math.min(start.y, end.y) - (arc + Math.random() * (CFG.arcMax - CFG.arcMin));
    const midY = clamp(midYraw, 40, vh - 80);

    const half = CFG.size / 2;

    const keyframes = [
      { transform: `translate(${start.x - half}px, ${start.y - half}px) scale(1)`,   opacity: 1,    offset: 0    },
      { transform: `translate(${midX   - half}px, ${midY   - half}px) scale(.92)`,  opacity: 1,    offset: 0.55 },
      { transform: `translate(${end.x  - half}px, ${end.y  - half}px) scale(.65)`,  opacity: 0.05, offset: 1    },
    ];

    const anim = el.animate(keyframes, {
      duration: CFG.duration,
      easing  : CFG.easing,
      delay   : i * CFG.delayStep,
      fill    : 'forwards',
    });

    anim.onfinish = () => { el.remove(); pulseTarget(target, CFG.pulseMs); };
  }
}

/* ───────────── фасад для квестов ─────────────
   Передай questDef и кнопку — мы сами выберем, что куда летит. */
export function flyRewardsToHeader({ questDef, buttonEl, icons = {}, cfg = {} }) {
  if (!questDef || !buttonEl) return;

  const cashIcon   = icons.cash   || ICONS_DATA.cash;
  const ticketIcon = icons.ticket || ICONS_DATA.tickets;
  const xpIcon     = icons.xp     || ICONS_DATA.xp;
  const skinIcon   = icons.skin   || ICONS_DATA.skins;
  const byVal      = { ...(icons.ticketsByValue || {}) };

  // $ (rewardCoins → cash)
  if (questDef.rewardCoins) {
    const cnt = Number(questDef.rewardCoins) || 1;
    flyToHeader({
      type: 'cash',
      sourceEl: buttonEl,
      imgSrc: cashIcon,
      countVisual: Math.round(Math.sqrt(cnt)) + 3,
      cfg,
    });
  }

  // tickets
  if (Array.isArray(questDef.rewardTickets)) {
    questDef.rewardTickets.forEach(t => {
      const icon = byVal[String(t.value ?? '')] || ticketIcon;
      const cnt  = Number(t.count ?? 1);
      flyToHeader({
        type: 'tickets',
        sourceEl: buttonEl,
        imgSrc: icon,
        countVisual: clamp(cnt, 3, 8),
        cfg,
      });
    });
  }

  // XP
  if (questDef.rewardXp) {
    const cnt = Number(questDef.rewardXp) || 1;
    flyToHeader({
      type: 'xp',
      sourceEl: buttonEl,
      imgSrc: xpIcon,
      countVisual: Math.round(Math.sqrt(cnt)) + 2,
      cfg,
    });
  }

  // Skins
  if (Array.isArray(questDef.rewardSkins)) {
    questDef.rewardSkins.forEach(s => {
      const icon = s.icon || skinIcon;
      const cnt  = Number(s.count || 1);
      flyToHeader({
        type: 'skins',
        sourceEl: buttonEl,
        imgSrc: icon,
        countVisual: clamp(cnt, 3, 8),
        cfg,
      });
    });
  }
}
